module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "contents",
    attrs: {
      "id": "con"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/9781416593218_Pro#Pro"
    }
  }, [_vm._v("Prologue")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/9781416593218_Ch01#Ch01"
    }
  }, [_vm._v("1. Spirit of Adventure")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/9781416593218_Ch02#Ch02"
    }
  }, [_vm._v("2. Welcome to Solomon Islands")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch03#Ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Coming in to Land")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch04#Ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Mr. Will, I Presume?")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch05#Ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Brave New World")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch06#Ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. An Innocent Encounter")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch07#Ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Worin Island")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch08#Ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Wuni and the Wantoks")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch09#Ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Keeping My Head")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch10#Ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Crown Derby")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch11#Ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. The Television Personality")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch12#Ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. The Big H")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch13#Ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. Mr.Wu")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch14#Ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. Catching the Boat")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch15#Ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. Mission Accomplished")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch16#Ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. The Feast of St. Andrew")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch17#Ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. Murder Most Fowl")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch18#Ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. Making a Splash")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch19#Ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. Once More unto the Beach …")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch20#Ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. No Smoke Without Fire")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch21#Ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Dokta Will")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch22#Ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. A Place in the Market")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Ch23#Ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. Chicken Willy’s—Nambawan Nice One")])])]), _c('p', {
    staticClass: "contentsEntry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/9781416593218_Epi#Epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15545f0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416593218_con.vue
// module id = 78
// module chunks = 0